import React from "react";
import Button from "./Button";

const WantProductTable = ({ products, onEdit, onDelete }) => {
  return (
    <div className="mt-6 space-y-4">

      {products.map((p) => (
        <div
          key={p.id}
          className="bg-white border rounded-lg shadow-sm p-4 flex flex-col gap-3"
        >

          {/* DETAILS */}
          <div className="flex flex-col gap-2">

            {/* NAME + STATUS */}
            <div className="flex items-center justify-between gap-3">

              <h3 className="text-lg font-semibold text-gray-800 truncate">
                {p.name}
              </h3>

              <span
                className={`shrink-0 px-2.5 py-1 rounded-full text-xs font-bold ${
                  p.is_active
                    ? "bg-green-100 text-green-700"
                    : "bg-gray-100 text-gray-600"
                }`}
              >
                {p.is_active ? "Active" : "Fulfilled"}
              </span>

            </div>

            {/* BUDGET */}
            {p.budget && (
              <p className="text-green-600 font-bold">
                Budget: R {p.budget}
              </p>
            )}

            {/* LOCATION */}
            {p.location && (
              <p className="text-sm text-gray-500">
                Location: {p.location}
              </p>
            )}

            {/* DESCRIPTION */}
            {p.description && (
              <p className="text-sm text-gray-600 line-clamp-2">
                {p.description}
              </p>
            )}

          </div>

          {/* ACTION BUTTONS */}
          <div className="flex gap-2">

            <Button
              onClick={() => onEdit(p)}
              className="flex-1"
            >
              Edit
            </Button>

            <Button
              variant="danger"
              onClick={() => onDelete(p.id)}
              className="flex-1"
            >
              Delete
            </Button>

          </div>

        </div>
      ))}

    </div>
  );
};

export default WantProductTable;